import type { ZodRawShape, ZodSchema } from 'zod';
import { z } from 'zod';

import { COUNTRY_CODES } from './constants';

export const CountryCodeSchema = z.enum(COUNTRY_CODES);

const objectOrEmptyArraySchema = (shape: ZodRawShape) =>
  z.preprocess((val) => {
    if (Array.isArray(val) && val.length === 0) {
      return {};
    }
    return val;
  }, z.object(shape));

type Branding = {
  colors?: {
    primary?: string;
    secondary?: string;
  };
  logos?: {
    app?: string;
  };
  isVoltBrandingHidden?: boolean;
  isVoltEducationalScreenHidden?: boolean;
  customerName?: string;
};

export const BrandingSchema = objectOrEmptyArraySchema({
  colors: objectOrEmptyArraySchema({
    primary: z.string().optional(),
    secondary: z.string().optional(),
  }).optional(),
  logos: objectOrEmptyArraySchema({
    app: z.string().url().optional(),
  }).optional(),
  isVoltBrandingHidden: z.boolean().optional(),
  isVoltEducationalScreenHidden: z.boolean().optional(),
  customerName: z.string().optional(),
}) as ZodSchema<Branding>;
